import { Box, CircularProgress } from '@material-ui/core';
import React, { ReactNode } from 'react';

interface SpinningProps {
  spinning: boolean;
  children: ReactNode;
}

export const Spinning = ({ spinning, children }: SpinningProps) => (
  <Box position='relative'>
    {children}
    {spinning && (
      <Box
        position='absolute'
        display='flex'
        alignItems='center'
        justifyContent='center'
        bgcolor='white'
        style={{ opacity: 0.5 }}
        top={0}
        left={0}
        right={0}
        bottom={0}
      >
        <CircularProgress size={24} />
      </Box>
    )}
  </Box>
);
